import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Journey from "./components/Journey";

function App() {
  const [lightMode, setlightMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? savedTheme === "light" : true;
  });

  useEffect(() => {
    document.documentElement.classList.toggle("dark", !lightMode);
    localStorage.setItem("theme", lightMode ? "light" : "dark");
  }, [lightMode]);

  return (
    <div
      className={`font-poppins ${
        lightMode ? "bg-gray-50 text-gray-800" : "bg-gray-900 text-gray-100"
      }`}
    >
      <Navbar lightMode={lightMode} setlightMode={setlightMode} />
      <Hero />
      <Projects />
      <Journey />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
